import type { StorageLocationType } from '@maker-toolchest/shared';
import { Badge, type BadgeProps } from '@/components/Badge';
import { Archive, Box, Grid, Flame, MoreHorizontal } from 'lucide-react';

const typeConfig: Record<StorageLocationType, { label: string; variant: BadgeProps['variant']; icon: React.ReactNode }> = {
  SHELF: { label: 'Shelf', variant: 'default', icon: <Grid className="h-3 w-3" /> },
  BIN: { label: 'Bin', variant: 'info', icon: <Box className="h-3 w-3" /> },
  CABINET: { label: 'Cabinet', variant: 'default', icon: <Archive className="h-3 w-3" /> },
  DRYER: { label: 'Dryer', variant: 'warning', icon: <Flame className="h-3 w-3" /> },
  OTHER: { label: 'Other', variant: 'default', icon: <MoreHorizontal className="h-3 w-3" /> },
};

export interface StorageLocationTypeBadgeProps {
  type: StorageLocationType;
  size?: 'sm' | 'md';
}

export function StorageLocationTypeBadge({ type, size = 'sm' }: StorageLocationTypeBadgeProps) {
  const config = typeConfig[type];

  return (
    <Badge variant={config.variant} size={size} className="gap-1">
      {config.icon}
      {config.label}
    </Badge>
  );
}
